import { createRouter } from '@tanstack/react-router';

import { startReturnNavigationTracking } from './lib/returnNavigation';
import { routeTree } from './routeTree.gen';

export const router = createRouter({ routeTree });

startReturnNavigationTracking(router);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
